import React from 'react';
import _ from 'lodash';
import autoBind from 'react-autobind';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import N from '@common/constraints/numbers.contraints';
import commonMessages from '@common/constraints/common.messages';
import Field from '@common/components/validation/field.validation';
import NumberOnly from '@common/components/inputs/numbersOnly.component';
import { Row, Col } from 'react-bootstrap';

import FocusHelper from '@common/helpers/focus.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    this.state = {
      showLookup: false,
    };
    autoBind(this);
  }

  get buttonSize() {
    return this.props.TamanhoButons || 10 - (this.props.TamanhoItem || 12);
  }

  onOpenLookup() {
    this.setState({ showLookup: true });
  }

  onCloseLookup() {
    this.setState({ showLookup: false });
  }

  onSelectLookup(onSelect) {
    return (dataItem) => {
      const { mapLookupItem } = this.props;
      const item = mapLookupItem ? mapLookupItem(dataItem) : dataItem;
      onSelect(item);
      this.onCloseLookup();
    };
  }

  onChange(field, form) {
    return (e) => {
      form.setFieldValue(this.props.name, e);
      this.dispatchChanges(e, form, field);
    };
  }

  onChildChanged(value, form) {
    const { editavel } = this.props;
    if (editavel) form.setFieldValue(this.props.name, value);
  }

  validate(value) {
    let errors;
    if (!value && !this.props.Obrigatorio) return;
    if (!value) value = 0;
    if (value || value == 0) {
      const { TipoNumero, Maximo, Minimo, MaxValor, MinValor } = this.props;
      value = parseFloat(value);

      //Valida MAX Number
      let maxNumber;
      if (Maximo) maxNumber = Maximo;
      else {
        switch (TipoNumero) {
          case 'long':
            maxNumber = N.MAX_LONG;
            break;
          case 'short':
            maxNumber = N.MAX_SHORT;
            break;
          case 'byte':
            maxNumber = N.MAX_BYTE;
            break;
          default:
            maxNumber = N.MAX_INTEGER;
            break;
        }
      }
      if (value > maxNumber) errors = commonMessages.validations.MAX_INVALID(maxNumber);

      let minNumber;
      if (Minimo) minNumber = Minimo;
      else {
        switch (TipoNumero) {
          case 'long':
            minNumber = N.MIN_LONG;
            break;
          case 'short':
            minNumber = N.MIN_SHORT;
            break;
          case 'byte':
            maxNumber = N.MAX_BYTE;
            break;
          default:
            minNumber = N.MIN_INTEGER;
            break;
        }
      }
      if (value < minNumber) errors = commonMessages.validations.MIN_INVALID(minNumber);

      // Valida Valor Maximo
      if (parseInt(value) > MaxValor) {
        errors = commonMessages.validations.MAX_VALOR(this.props.MaxValor);
      }

      // Valida Valor Minimo
      if (parseInt(value) < MinValor) {
        errors = commonMessages.validations.MIN_VALOR(this.props.MinValor);
      }
    }

    return errors;
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props, validate } = this;
    const {
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      TipoNumero,
      Maximo,
      Minimo,
      Negativo,
      Placeholder,
      lookup,
      Tamanho,
      name,
      onKeyDown,
      allowseparator,
    } = props;

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChange, onChangeAsync, onBlur, preventEnterKey }) => {
          return (
            <Row>
              <Col>
                <LabeledInput {...props}>
                  <NumberOnly
                    value={value}
                    name={name}
                    tooltip={Tooltip === false ? '' : Tooltip || Label}
                    className={`form-control ${hasError ? 'form-invalid' : ''}`}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    onChange={onChangeAsync}
                    onKeyPress={preventEnterKey}
                    onBlur={props.onBlur ? onBlur : undefined}
                    numberType={TipoNumero}
                    max={Maximo}
                    min={Minimo}
                    maxLength={Tamanho}
                    allowNegative={Negativo}
                    allowseparator={allowseparator}
                    placeholder={Placeholder === false ? '' : Placeholder || Label}
                    onKeyDown={onKeyDown}
                  />
                </LabeledInput>
              </Col>
              {lookup && (
                <Col lg={this.buttonSize}>
                  <div
                    className="container-lookup div-button-right"
                    style={{
                      paddingTop: '1px',
                    }}
                  >
                    <label style={{ lineHeight: '1' }}>&nbsp;</label>
                    <button
                      type="button"
                      className="btn btn-primary btn-custom mr-3"
                      title={'Pesquisar'}
                      onClick={this.onOpenLookup}
                      disabled={Desabilitado}
                    >
                      <i className={'pointer-events-none fa fa-search'} />
                    </button>
                    {React.cloneElement(lookup, {
                      onSelect: this.onSelectLookup(onChange).bind(this),
                      onClose: this.onCloseLookup.bind(this),
                      show: this.state.showLookup,
                    })}
                  </div>
                </Col>
              )}
            </Row>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control">{field.value != undefined ? field.value : ''}</label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{field.value != undefined ? field.value : ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
